import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "flush", "use"];
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledMain = styled.main.withConfig({
  displayName: "Main__StyledMain"
})(({
  $flush,
  $use,
  $cssStyles,
  theme
}) => {
  return Object.assign({
    padding: `0 ${theme.space['1100']} ${theme.space['1100']}`,
    backgroundColor: $use === 'dark' ? theme.color['fill-surface-raised'] : undefined,
    paddingInline: $flush ? 0 : undefined,
    paddingTop: $flush ? 0 : undefined
  }, $cssStyles);
});

/**
 * Main body of the app. There should only be one per application.
 *
 * @category Layout
 */

export const Main = _ref => {
  let {
      children,
      flush,
      use
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledMain, Object.assign({}, domProps, {
    $cssStyles: cssStyles,
    $flush: flush,
    $use: use,
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'Main',
    children: children
  }));
};
Main.displayName = 'Main';